module.exports = __webpack_public_path__ + "img/hospitium-14.75066d06.jpg";